// @module Tavanoteam.Calculator.Calculator
define('Calculator.Coatings.View'
    , [
        'calculator_coatings.tpl'

        , 'Backbone'
        , 'jQuery'
    ]
    , function (
        calculator_coatings_tpl

        , Backbone
        , jQuery
    ) {
        'use strict';

        return Backbone.View.extend({

            template: calculator_coatings_tpl

            , initialize: function (options) {
                this.container = options.container;
                this.isMainPage = options.isMainPage;
            }

            , events: {
                'click [data-action="caclulate-coatings-wet-mils"]': 'calculateWetMils',
                'click [data-action="caclulate-coatings-dry-mils"]': 'calculateDryMils',
                'click [data-action="reset-wet-mils"]': 'resetWetFields',
                'click [data-action="reset-dry-mils"]': 'resetDryFields'
            }

            , calculateWetMils: function calculateWetMils() {
                if (this.inModal) {
                    var wetOutputFieldsContainer = document.getElementById('in-modal-calculator-coatings-output-fields-wet-container');
                    wetOutputFieldsContainer.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });

                    //input fields
                    var wetMils = $('#in-modal-coatings-wet-mils').val(),
                        squareFootageWet = $('#in-modal-coatings-square-footage-wet').val();

                    //output fields
                    var coverageRateWet = $('#in-modal-coatings-coverage-rate-wet'),
                        materialNeededWet = $('#in-modal-coatings-material-needed-wet');
                } else {
                    //input fields
                    var wetMils = $('#coatings-wet-mils').val(),
                        squareFootageWet = $('#coatings-square-footage-wet').val();

                    //output fields
                    var coverageRateWet = $('#coatings-coverage-rate-wet'),
                        materialNeededWet = $('#coatings-material-needed-wet');
                }

                var coverageRateResult = 1604 / parseFloat(wetMils);
                var materialNeededResult = squareFootageWet / coverageRateResult;

                coverageRateWet.val(coverageRateResult.toFixed(2) + ' per gallon');
                materialNeededWet.val(materialNeededResult.toFixed(2) + ' gallons');
            }

            , calculateDryMils: function calculateDryMils() {
                if (this.inModal) {
                    var dryOutputFieldsContainer = document.getElementById('in-modal-calculator-coatings-output-fields-dry-container');
                    dryOutputFieldsContainer.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });

                    //input fields
                    var dryMils = $('#in-modal-coatings-dry-mils').val(),
                        solidsContent = $('#in-modal-coatings-solids-contents').val(),
                        squareFootageDry = $('#in-modal-coatings-square-footage-dry').val();

                    //output fields
                    var wetMilsDry = $('#in-modal-coatings-dry-wet-mils'),
                        wetMilsDryInches = $('#in-modal-coatings-dry-wet-mils-inches'),
                        coverageRateDry = $('#in-modal-coatings-coverage-rate-dry'),
                        materialNeededDry = $('#in-modal-coatings-material-needed-dry');
                } else {
                    //input fields
                    var dryMils = $('#coatings-dry-mils').val(),
                        solidsContent = $('#coatings-solids-contents').val(),
                        squareFootageDry = $('#coatings-square-footage-dry').val();

                    //output fields
                    var wetMilsDry = $('#coatings-dry-wet-mils'),
                        wetMilsDryInches = $('#coatings-dry-wet-mils-inches'),
                        coverageRateDry = $('#coatings-coverage-rate-dry'),
                        materialNeededDry = $('#coatings-material-needed-dry');
                }

                var wetFilm = parseFloat(dryMils) / (parseFloat(solidsContent) / 100);
                var dryCoverageRate = 1604 / parseFloat(wetFilm);
                var dryMaterialNeeded = squareFootageDry / dryCoverageRate;

                wetMilsDry.val(wetFilm.toFixed(1));
                wetMilsDryInches.val(this.getWetMilsDryInches(wetMilsDry.val()));
                coverageRateDry.val(dryCoverageRate.toFixed(1) + ' SF per gallon');
                materialNeededDry.val(dryMaterialNeeded.toFixed(1) + ' gallons');
            }

            , getWetMilsDryInches: function getWetMilsDryInches(wetMilsDry) {
                var decimal = parseInt(wetMilsDry) / 1000,
                    decimalString = decimal.toString(),
                    decimalArray = decimalString.split("."),
                    leftDecimalPart = decimalArray[0], // 1
                    rightDecimalPart = decimalArray[1]; // 75

                var numerator = leftDecimalPart + rightDecimalPart, // 175
                    denominator = Math.pow(10, rightDecimalPart.length), // 100
                    factor = this.gethighestCommonFactor(numerator, denominator); // 25

                denominator /= factor;
                numerator /= factor;

                return numerator + "/" + denominator;
            }

            , gethighestCommonFactor: function gethighestCommonFactor(numerator, denominator) {
                if (denominator == 0) return numerator;

                return this.gethighestCommonFactor(denominator, numerator % denominator);
            }

            , resetWetFields: function resetWetFields() {
                $('.calculator-coatings-wet-container').find('input:text').val('');
            }

            , resetDryFields: function resetDryFields() {
                $('.calculator-coatings-dry-container').find('input:text').val('');
            }

            , getContext: function getContext()
            {
                return {
                    isMainPage : this.isMainPage ? this.isMainPage : false
                }
            }
        });
    });
